<template>
  <div class="skin-profile-form">
    <IconButton
      class="skin-profile-form__close-button"
      data-cy="close-form"
      type="button"
      icon="times-circle"
      icon-type="far"
      @click="$emit('close')"
    />

    <form class="skin-profile-form__form" @submit.prevent="emitSave">
      <SkinProfileFormInput
        label="Tải hình da"
        type="file"
        data-cy="file-input"
        required
        @change="setTargetFile"
      />

      <SkinProfileFormInput
        v-model="feeling"
        label="Bạn cảm thấy thế nào"
        data-cy="input-feeling"
        type="text"
        required
      />

      <SkinProfileFormInput
        v-model="skinType"
        label="Loại da của bạn"
        data-cy="input-skin-type"
        type="text"
        required
      />
      <SkinProfileFormInput
        v-model="skinTime"
        label="Thời gian chăm sóc da"
        data-cy="input-skin-time"
        type="text"
        required
      />
      <SkinProfileFormInput
        v-model="sleep"
        label="Giấc ngủ của bạn"
        data-cy="input-sleep"
        type="text"
        required
      />
      <SkinProfileFormInput
        v-model="note"
        label="Ghi chú"
        data-cy="input-note"
        type="text"
      />

      <NormalButton class="mt-2" data-cy="save-skin-profile-button" full-width
        >Lưu hồ sơ da</NormalButton
      >
    </form>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { SkinProfileTextFields } from "@/controller/skin-profile";
import SkinProfileFormInput from "./SkinProfileFormInput.vue";
import NormalButton from "@/components/NormalButton.vue";
import IconButton from "@/components/IconButton.vue";

export default defineComponent({
  name: "SkinProfileForm",

  components: {
    SkinProfileFormInput,
    NormalButton,
    IconButton
  },

  data() {
    return {
      feeling: "",
      skinType: "",
      skinTime: "",
      sleep: "",
      note: "",
      file: null as null | File
    };
  },

  methods: {
    emitSave() {
      const skinProfile: SkinProfileTextFields = {
        feeling: this.feeling,
        skinType: this.skinType,
        skinTime: this.skinTime,
        sleep: this.sleep,
        note: this.note
      };
      this.$emit("save", skinProfile, this.file);
    },

    setTargetFile(event: Event) {
      const target = event.target as HTMLInputElement;
      const files = target.files as FileList;
      this.file = files[0];
    }
  }
});
</script>

<style lang="scss" scoped>
.skin-profile-form {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
}

.skin-profile-form__form {
  overflow-y: auto;
  padding: 1rem;
  max-width: 400px;
  max-height: 80%;
  width: 80%;
  border-radius: 6px;
  background: white;
}

.skin-profile-form__close-button {
  position: absolute;
  top: 1em;
  right: 0.6rem;
  color: white;
}
</style>
